import { setCookie } from '@/utils/cookies.js';
import { common } from './http.js';
import router from '@/router';

export const loginApi = (login, password) => {
    const response = common('auth./auth/user/login', { login, password });
    return response;
};

export const renewalToken = async renewal => {
    const response = await common('auth./token/renew', { renewal });
    if (response.result) {
        setCookie('token', response.token);
        setCookie('renewal', response.renewal);
    }
    if (!response.result) {
        router.push({
            name: 'loginForm',
        });
    }
    return response;
};
